/**
 * Remove the leading `/` of a slug.
 * @param slug - slug to normalize.
 * @returns the slug without its leading `/`.
 */
export const normalizeSlug = (slug: string) => {
    const normalized = slug.indexOf('/') === 0 ? slug.slice(1, slug.length) : slug;

    return normalized;
};
